import React, { Component } from 'react';

const FooterInfo = () => {
    return (
        <React.Fragment>
            <ul>
                <li className="place">전라남도 나주시 그린로 63 <span className="mbr"></span> 차이나매직, &nbsp;&nbsp; <span className="line">사업자 등록번호 </span>254-19-00929</li>
                <li className="site">chinamagic8@naver.com</li>
                <li className="tel"><span className="line">TEL</span>010 - 8888 - 8084</li>
            </ul>
        </React.Fragment>
    )
}

export default FooterInfo;